import { render, staticRenderFns } from "./vpn-login.vue?vue&type=template&id=c6304618&scoped=true&"
import script from "./vpn-login.vue?vue&type=script&lang=js&"
export * from "./vpn-login.vue?vue&type=script&lang=js&"
import style0 from "./vpn-login.vue?vue&type=style&index=0&id=c6304618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6304618",
  null
  
)

export default component.exports